import { SvgIcon } from "@material-ui/core";

export const ArrowDownIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M14.5745 9.99961C15.0245 9.99961 15.337 10.2038 15.512 10.6121C15.687 11.0204 15.6162 11.3829 15.2995 11.6996L12.6995 14.2996C12.5995 14.3996 12.4912 14.4746 12.3745 14.5246C12.2579 14.5746 12.1329 14.5996 11.9995 14.5996C11.8662 14.5996 11.7412 14.5746 11.6245 14.5246C11.5079 14.4746 11.3995 14.3996 11.2995 14.2996L8.69954 11.6996C8.38287 11.3829 8.31204 11.0204 8.48704 10.6121C8.66204 10.2038 8.97454 9.99961 9.42454 9.99961L14.5745 9.99961Z"
        fill={props.fill || "currentColor"}
      />
    </SvgIcon>
  );
};
